import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";
import api from "./api";
import VueCookies from "vue-cookies";

Vue.use(Vuex);

function addDayToSortedPrices(date, price, sortedPrices) {
  const year = date.year();
  const month = date.month();
  const day = date.date();

  if (!Array.isArray(sortedPrices[year])) {
    sortedPrices[year] = [];
  }

  if (!Array.isArray(sortedPrices[year][month])) {
    sortedPrices[year][month] = [];
    sortedPrices[year][month]["days"] = [];
  }

  sortedPrices[year][month]["days"][day] = price;

  return sortedPrices;
}

export default new Vuex.Store({
  state: {
    voyage: window.funnel_data.voyage_data,
    aeroportsListe: window.funnel_data.aeroports,
    aeroportsActifs: [],
    sansTransport: false,
    pictos: window.funnel_data.pictos,
    url_p2: window.funnel_data.url_p2,
    dureesActives: [],
    selectedAeroport: null,
    selectedDuree: null,
    apiLoaded: false,
    cookie: null,
    chambres: [
      {
        adulte: 2,
        enfant: [],
      },
    ],
    prices: [],
    viewMonth: true,
    activeYearIndex: 0,
    activeMonthIndex: 0,
    dayReservation: null,
    priceReservation: null,
    isLoading: false,
    monthsList: [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ],
    daysList: ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"],
  },

  mutations: {
    UPDATE_AEROPORT(state, value) {
      state.selectedAeroport = value;
    },
    UPDATE_LOADING(state, value) {
      state.isLoading = value;
    },
    ADD_CHAMBRE(state) {
      state.chambres.push({
        adulte: 0,
        enfant: [],
      });
    },
    REMOVE_CHAMBRE(state) {
      state.chambres.pop();
    },
    UPDATE_CHAMBRES(state, value) {
      state.chambres = value;
    },
    UPDATE_DUREE(state, value) {
      state.selectedDuree = value;
    },
    REFRESH_PRICES(state, value) {
      state.prices = value;
    },
    UPDATE_VIEW_MONTH(state, value) {
      state.viewMonth = value;
    },
    UPDATE_ACTIVE_YEAR_INDEX(state, value) {
      state.activeYearIndex = value;
    },
    UPDATE_ACTIVE_MONTH_INDEX(state, value) {
      state.activeMonthIndex = value;
    },
    SET_DAY_RESERVATION(state, value) {
      state.dayReservation = value;
    },
    SET_PRICE_RESERVATION(state, value) {
      state.priceReservation = value;
    },
    UPDATE_DUREES(state, value) {
      state.durees = value;
    },
    UPDATE_DUREES_ACTIVES(state, value) {
      state.dureesActives = value;
    },
    UPDATE_AEROPORTS_ACTIFS(state, value) {
      state.aeroportsActifs = value;
    },
    IS_SANS_TRANSPORT(state) {
      state.sansTransport = true;
    },
  },

  actions: {
    init({ state, dispatch }) {
      let voyageElastic = false;

      if (VueCookies.isKey("voyageElastic")) {
        voyageElastic = VueCookies.get("voyageElastic");
        if (voyageElastic.id == state.voyage.id) {
          state.cookie = {
            nb_nuits: voyageElastic.nb_nuits,
            aeroport: voyageElastic.selectedAeroport,
            mois: voyageElastic.mois,
          };
        }
      }

      dispatch("checkAeroports");

      dispatch("refreshApi").then(() => {
        if (state.cookie != null && state.cookie.mois) {
          const arrayMois = state.cookie.mois.split("/");

          const moisAChercher = {
            month: parseInt(arrayMois[0]) - 1,
            year: parseInt(arrayMois[1]),
          };

          window.setTimeout(function() {
            dispatch("goToMonth", moisAChercher);
          }, 300);
        }
      });
    },

    refreshApi({ state, commit }) {
      if (state.voyage.template == 1) {
        if (state.selectedAeroport == null) return;
      } else {
        if (state.selectedAeroport == null || state.selectedDuree == null)
          return;
      }

      state.apiLoaded = true;
      commit("UPDATE_LOADING", true);

      return api.getFlux().then(({ data }) => {
        let prices = [];

        for (const hit in data.hits.hits) {
          let source = data.hits.hits[hit]._source;

          if (source.BORNE_DATE != "nan") {
            const beginDate = source.BORNE_DATE.match(/Begin="([^"]*)"/);
            const endDate = source.BORNE_DATE.match(/End="([^"]*)"/);

            source.beginDate = moment(beginDate[1]);
            source.endDate = moment(endDate[1]);
          }

          source.momentDate = moment(source.DATE_DEPART);

          prices.push(source);
        }

        let sortedPrices = [];

        // On parse d'abord les BORNE_DATE pour les ajouter

        prices.forEach(function(price) {
          if (!price.beginDate || !price.endDate) return;

          let currentDate = price.beginDate.clone();
          while (currentDate.isSameOrBefore(price.endDate, "day")) {
            addDayToSortedPrices(currentDate, price, sortedPrices);
            // console.log(currentDate.format("YYYY-MM-DD")); // or perform any operation with currentDate
            currentDate.add(1, "days");
          }
        });

        // On parse ensuite les momentDate

        prices.forEach(function(price) {
          addDayToSortedPrices(price.momentDate, price, sortedPrices);
        });

        sortedPrices.forEach(function(year, indexYear) {
          year.forEach(function(month, indexMonth) {
            let bestPrice = 999999;

            month.days.forEach(function(day) {
              bestPrice = Math.min(bestPrice, day.PRIX_PAR_PERSONNE);
            });

            sortedPrices[indexYear][indexMonth]["bestPrice"] = bestPrice;
          });
        });

        commit("REFRESH_PRICES", sortedPrices);
        commit("UPDATE_LOADING", false);
      });
    },

    checkDurees({ commit, state }) {
      if (!state.selectedAeroport) return;

      if (state.voyage.template == 1) return;

      return api.getDurees().then(({ data }) => {
        let dureesActives = [];
        data.aggregations.durees.buckets.forEach(function(duree) {
          dureesActives.push(duree.key);
        });

        dureesActives.sort(function(a, b) {
          return a - b;
        });

        commit("UPDATE_DUREES_ACTIVES", dureesActives);

        let selectedDuree;

        if (
          state.selectedDuree &&
          dureesActives.includes(state.selectedDuree)
        ) {
          selectedDuree = state.selectedDuree;
        } else if (
          state.cookie &&
          state.cookie.nb_nuits &&
          dureesActives.includes(state.cookie.nb_nuits)
        ) {
          selectedDuree = state.cookie.nb_nuits;
        } else {
          selectedDuree = dureesActives[0];
        }

        commit("UPDATE_DUREE", selectedDuree);
      });
    },

    checkAeroports({ commit, state, dispatch }) {
      return api.getAeroports().then(({ data }) => {
        let aeroportsActifs = [];

        data.aggregations.aeroports.buckets.forEach(function(aeroport) {
          aeroportsActifs.push(aeroport.key);
        });

        commit("UPDATE_AEROPORTS_ACTIFS", aeroportsActifs);

        let selectedAeroport;

        if (
          state.cookie &&
          state.cookie.aeroport &&
          state.aeroportsActifs.includes(state.cookie.aeroport)
        ) {
          selectedAeroport = state.cookie.aeroport;
        } else if (state.aeroportsActifs.includes("PAR")) {
          selectedAeroport = "PAR";
        } else {
          selectedAeroport = state.aeroportsActifs[0];
        }

        commit("UPDATE_AEROPORT", selectedAeroport);

        if (selectedAeroport === "XXX") {
          commit("IS_SANS_TRANSPORT", selectedAeroport);
          dispatch("refreshApi");
        }

        dispatch("checkDurees");
      });
    },

    updateAeroport({ commit, dispatch }, value) {
      commit("UPDATE_AEROPORT", value);
      dispatch("checkDurees");
      dispatch("refreshApi");
    },
    updateDuree({ commit, dispatch }, value) {
      commit("UPDATE_DUREE", value);
      dispatch("refreshApi");
    },
    updateChambres({ getters, commit }, value) {
      if (value == getters.nombreChambres + 1) {
        commit("ADD_CHAMBRE");
      } else if (value == getters.nombreChambres - 1) {
        commit("REMOVE_CHAMBRE");
      }
    },
    updateAdulte({ state, commit }, data) {
      let chambres = state.chambres;

      chambres[data.index].adulte = data.value;

      commit("UPDATE_CHAMBRES", chambres);
    },

    updateNombreEnfant({ state, commit }, data) {
      let chambres = state.chambres;

      if (chambres[data.index].enfant.length < data.value) {
        chambres[data.index].enfant.push(0);
      } else if (chambres[data.index].enfant.length > data.value) {
        chambres[data.index].enfant.pop();
      }

      commit("UPDATE_CHAMBRES", chambres);
    },

    updateAgeEnfantChambre({ state, commit }, data) {
      let chambres = state.chambres;
      chambres[data.numeroChambre].enfant[data.indexEnfant] = data.value;

      commit("UPDATE_CHAMBRES", chambres);
    },

    updateViewMonth({ commit }, value) {
      commit("UPDATE_VIEW_MONTH", value);
    },

    nextYear({ state, getters, commit }) {
      if (state.activeYearIndex + 1 < getters.availableYears.length) {
        commit("UPDATE_ACTIVE_YEAR_INDEX", state.activeYearIndex + 1);
      }
    },

    prevYear({ state, commit }) {
      if (state.activeYearIndex - 1 >= 0) {
        commit("UPDATE_ACTIVE_YEAR_INDEX", state.activeYearIndex - 1);
      }
    },

    nextMonth({ state, getters, commit }) {
      if (state.activeMonthIndex + 1 < getters.availableMonths.length) {
        commit("UPDATE_ACTIVE_MONTH_INDEX", state.activeMonthIndex + 1);
      }
    },

    prevMonth({ state, commit }) {
      if (state.activeMonthIndex - 1 >= 0) {
        commit("UPDATE_ACTIVE_MONTH_INDEX", state.activeMonthIndex - 1);
      }
    },

    goToMonth({ getters, commit }, value) {
      getters.availableMonths.forEach(function(mois, index) {
        if (mois.month == value.month && mois.year == value.year) {
          commit(
            "UPDATE_ACTIVE_YEAR_INDEX",
            getters.availableYears.indexOf(value.year)
          );
          commit("UPDATE_ACTIVE_MONTH_INDEX", index);
          commit("UPDATE_VIEW_MONTH", false);
        }
      });
    },

    setDayReservation({ commit }, value) {
      commit("SET_DAY_RESERVATION", value);
    },

    setPriceReservation({ commit }, value) {
      commit("SET_PRICE_RESERVATION", value);
    },
  },
  getters: {
    nombreChambres: (state) => {
      return state.chambres.length;
    },

    getBestPriceByMonth: (state, getters) => (month) => {
      let minimumPrice = 0;

      let year = getters.activeYear;

      if (year in state.prices) {
        if (month in state.prices[year]) {
          return state.prices[year][month].bestPrice;
        }
      }

      return minimumPrice;
    },

    availableYears: (state) => {
      let availableYears = [];

      state.prices.forEach(function(year, index) {
        availableYears.push(index);
      });

      return availableYears;
    },

    availableMonths: (state) => {
      let availableMonths = [];

      state.prices.forEach(function(year, indexYear) {
        year.forEach(function(month, indexMonth) {
          availableMonths.push({
            month: indexMonth,
            year: indexYear,
          });
        });
      });

      return availableMonths;
    },

    activeYear: (state, getters) => {
      return getters.availableYears[state.activeYearIndex];
    },

    activeMonth: (state, getters) => {
      return getters.availableMonths[state.activeMonthIndex];
    },

    getPriceByDay: (state, getters) => (day) => {
      if (day == 0) return false;

      const activeMonth = getters.activeMonth;

      if (Array.isArray(state.prices[activeMonth.year])) {
        if (Array.isArray(state.prices[activeMonth.year][activeMonth.month])) {
          if (day in state.prices[activeMonth.year][activeMonth.month].days) {
            return state.prices[activeMonth.year][activeMonth.month].days[day]
              .PRIX_PAR_PERSONNE;
          }
        }
      }

      return false;
    },

    durees: (state) => {
      let durees = [];

      state.dureesActives.forEach(function(duree) {
        durees.push({
          text: duree + " nuits",
          value: duree,
        });
      });

      return durees;
    },

    aeroports: (state) => {
      let aeroports = [];

      state.aeroportsListe.forEach(function(aeroport) {
        if (state.aeroportsActifs.includes(aeroport.value))
          aeroports.push(aeroport);
      });

      return aeroports;
    },

    getURLP2: (state) => {
      let url = new URL(state.url_p2);
      url.searchParams.set("TRNTPD", "BC18");
      url.searchParams.set("MSDESD", "S");
      url.searchParams.set("SLBRDD", "5");
      url.searchParams.set("TURRFD", state.voyage.code_resa);
      url.searchParams.set(
        "DPDMYD",
        moment(state.dayReservation).format("DD/MM/YYYY")
      );
      url.searchParams.set("DPAPTD", state.selectedAeroport);

      if (state.selectedDuree) {
        url.searchParams.set("NRNTSD", state.selectedDuree);
      } else {
        url.searchParams.set("NRNTSD", state.voyage.nb_nuits);
      }

      url.searchParams.set("NRRMSD", state.chambres.length);

      let nombrePassagers = 0;

      state.chambres.forEach(function(chambre, indexChambre) {
        indexChambre = indexChambre + 1;

        url.searchParams.set("NRAD" + indexChambre + "D", chambre.adulte);
        nombrePassagers += chambre.adulte;

        if (chambre.enfant.length) {
          url.searchParams.set(
            "NRCH" + indexChambre + "D",
            chambre.enfant.length
          );
          chambre.enfant.forEach(function(ageEnfant) {
            nombrePassagers++;
            url.searchParams.set("PAGE" + nombrePassagers + "D", ageEnfant);
          });
        }
      });

      return url;
    },
  },
  modules: {},
});
